import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  anchor: {
    position: 'relative'
  },
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 999
  },
  menu: {
    position: 'absolute',
    top: '100%',
    zIndex: 1000,
    backgroundColor: 'var(--surface-bg-color-d1)',
    border: '1px solid var(--border-color)',
    borderRadius: '4px',
    padding: '4px 0',
    minWidth: '180px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    fontSize: '13px',
    color: 'var(--font-color-main)',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    width: '100%',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: 'var(--surface-bg-color-d4)'
    }
  },
  menuItemDanger: {
    color: 'var(--color-error-500)'
  },
  divider: {
    height: '1px',
    backgroundColor: 'var(--border-color)',
    margin: '4px 0'
  },
  shortcut: {
    marginLeft: 'auto',
    fontSize: '11px',
    color: 'var(--color-contrast-neutral-300)'
  }
}))

function DropdownMenu ({ open, onClose, align, children }) {
  const classes = useStyles()

  if (!open) return null

  const posStyle = align === 'right' ? { right: 0 } : { left: 0 }

  return (
    <>
      <div className={classes.backdrop} onClick={onClose} />
      <div className={classes.menu} style={posStyle}>
        {children}
      </div>
    </>
  )
}

DropdownMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node
}

DropdownMenu.defaultProps = {
  align: 'left'
}

function DropdownMenuItem ({ onClick, disabled, danger, children }) {
  const classes = useStyles()
  return (
    <button
      className={`${classes.menuItem} ${danger ? classes.menuItemDanger : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

DropdownMenuItem.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  children: PropTypes.node
}

function DropdownMenuDivider () {
  const classes = useStyles()
  return <div className={classes.divider} />
}

function DropdownMenuShortcut ({ children }) {
  const classes = useStyles()
  return <span className={classes.shortcut}>{children}</span>
}

DropdownMenuShortcut.propTypes = {
  children: PropTypes.node
}

export default DropdownMenu
export { DropdownMenu, DropdownMenuItem, DropdownMenuDivider, DropdownMenuShortcut }
